var o = function (r) {
    return r.outline = "outline", r.ghosty = "ghosty", r.simple = "simple", r;
  }(o || {}),
  a = function (r) {
    return r.normal = "normal", r.large = "large", r;
  }(a || {});
export { o as SelectKind, a as SelectSize };